import { t } from "@travily/i18n";
import { favoritesDestinationsPath, favoritesPath, favoritesProgramsPath } from "@travily/routes";
import type { FavoritesTab } from "@/pages/favorites/components/FavoritesFrame";

/** Tab definitions shared by the three favorites pages. */
export function useFavoritesTabs(): FavoritesTab[] {
  return [
    { key: "marketplace", label: t("web.favorites.index.tabs.marketplace"), href: favoritesPath() },
    { key: "destinations", label: t("web.favorites.index.tabs.destinations"), href: favoritesDestinationsPath() },
    { key: "programs", label: t("web.favorites.index.tabs.programs"), href: favoritesProgramsPath() },
  ];
}
